// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R1ck","select":"styles_select__3HPID"};